// extracted by mini-css-extract-plugin
var _1 = "webpack-containers-Extraction-Extract-module__container webpack-containers-Extraction-splitable-module__container";
var _2 = "webpack-containers-Extraction-Extract-module__formPanel";
var _3 = "webpack-containers-Extraction-Extract-module__forms";
var _4 = "webpack-containers-Extraction-Extract-module__header webpack-containers-Extraction-splitable-module__header";
var _5 = "webpack-containers-Extraction-Extract-module__split webpack-containers-Extraction-splitable-module__split";
export { _1 as "container", _2 as "formPanel", _3 as "forms", _4 as "header", _5 as "split" }
